<template>
  <div id="vessel-form">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <div class="title-area">
                <span class="title">船舶情報</span>
                <div v-if="isViewMode" class="back-button" @click="backToMaster">
                  <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
                  <span>一覧へ戻る</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-column left-column">
                  <div class="input-row">
                    <div class="string-input">
                      <div class="label">
                        <span class="label">{{inputs.name.label}}</span>
                        <span v-if="!isViewMode" class="validation-label">*</span>
                      </div>
                      <span v-if="isViewMode">{{inputs.name.value}}</span>
                      <vs-input
                        v-else
                        class="name-input"
                        color="#2D9CDB"
                        v-model="inputs.name.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.label.label}}</span>
                      <span v-if="isViewMode">{{inputs.label.value}}</span>
                      <vs-input
                        v-else
                        class="label-input"
                        color="#2D9CDB"
                        v-model="inputs.label.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.adminCode.label}}</span>
                      <span v-if="isViewMode">{{inputs.adminCode.value}}</span>
                      <vs-input
                        v-else
                        class="admin_code-input"
                        color="#2D9CDB"
                        v-model="inputs.adminCode.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.mmsi.label}}</span>
                      <span v-if="isViewMode">{{inputs.mmsi.value}}</span>
                      <vs-input
                        v-else
                        class="mmsi-input"
                        color="#2D9CDB"
                        v-model="inputs.mmsi.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.imo.label}}</span>
                      <span v-if="isViewMode">{{inputs.imo.value}}</span>
                      <vs-input
                        v-else
                        class="imo-input"
                        color="#2D9CDB"
                        v-model="inputs.imo.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.callSign.label}}</span>
                      <span v-if="isViewMode">{{inputs.callSign.value}}</span>
                      <vs-input
                        v-else
                        class="call-sign-input"
                        color="#2D9CDB"
                        v-model="inputs.callSign.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.tonnage.label}}</span>
                      <span v-if="isViewMode">{{inputs.tonnage.value}}</span>
                      <vs-input
                        v-else
                        class="tonnage-input"
                        color="#2D9CDB"
                        v-model="inputs.tonnage.value"
                      ></vs-input>
                    </div>
                  </div>
                </div>
                <div class="input-column right-column">
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.defaultVehiclesCount.label}}</span>
                      <span v-if="isViewMode">{{inputs.defaultVehiclesCount.value}}</span>
                      <vs-input
                        v-else
                        class="default-vehicles-count-input number-input"
                        color="#2D9CDB"
                        v-model="inputs.defaultVehiclesCount.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.defaultTugboatsCount.label}}</span>
                      <span v-if="isViewMode">{{inputs.defaultTugboatsCount.value}}</span>
                      <vs-input
                        v-else
                        class="default-tugboats-count-input number-input"
                        color="#2D9CDB"
                        v-model="inputs.defaultTugboatsCount.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.defaultRopePickingBoatsCount.label}}</span>
                      <span v-if="isViewMode">{{inputs.defaultRopePickingBoatsCount.value}}</span>
                      <vs-input
                        v-else
                        class="default-rope-picking-boats-count-input number-input"
                        color="#2D9CDB"
                        v-model="inputs.defaultRopePickingBoatsCount.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.headCount.label}}</span>
                      <span v-if="isViewMode">{{inputs.headCount.value}}</span>
                      <vs-input
                        v-else
                        class="head-count-input number-input"
                        color="#2D9CDB"
                        v-model="inputs.headCount.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.departureHeadCount.label}}</span>
                      <span v-if="isViewMode">{{inputs.departureHeadCount.value}}</span>
                      <vs-input
                        v-else
                        class="head-count-input number-input"
                        color="#2D9CDB"
                        v-model="inputs.departureHeadCount.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.tags.label}}</span>
                      <span v-if="isViewMode" class="tag-area">
                        <template
                          v-for="(tag, index) in inputs.tags.value"
                        >
                          <div 
                            :key="index"
                            class="multiselect__tag read-only-tag"
                            :style="'background:#'+tag.color.color_hex+';'"
                          >
                            {{tag.name}}
                          </div>

                        </template>
                        
                      </span>
                      <div v-else class="required-note-input">
                        <multiselect 
                          v-model="inputs.tags.value"
                          tag-placeholder="タグが見つかりません"
                          placeholder="タグを追加できます"
                          selectLabel="選択する"
                          selectedLabel="選択済"
                          deselectLabel="削除する"
                          label="name"
                          track-by="id"
                          :options="options"
                          :multiple="true"
                          :taggable="true"
                        >
                          <template slot="tag" slot-scope="props">
                            <span class="multiselect__tag" :style="'background:#'+props.option.color.color_hex+';'">
                              <span>{{props.option.name}}</span>
                              <i tabindex="1"
                                @keypress.enter.prevent="removeTagById(props.option.id)"
                                @mousedown.prevent="removeTagById(props.option.id)"
                                class="multiselect__tag-icon">
                              </i>
                            </span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div class="tag-option-item">
                              <color-chip :color="props.option.color"></color-chip>
                              <span>{{ props.option.name }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="text-are-input">
                      <span class="label">{{inputs.requiredNote.label}}</span>
                      <span v-if="isViewMode">{{inputs.requiredNote.value}}</span>
                      <vs-textarea
                        v-else
                        class="required-note-input"
                        width="300px"
                        v-model="inputs.requiredNote.value"
                      ></vs-textarea>
                    </div>
                  </div>
                  <div class="input-row" v-if="isViewMode">
                    <div class="string-input">
                      <span class="label">作成日時</span>
                      <span>{{createdAt}}</span>
                    </div>
                  </div>
                  <div class="input-row" v-if="isViewMode">
                    <div class="string-input">
                      <span class="label">更新日時</span>
                      <span>{{updatedAt}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="isViewMode">
                <vs-button color="#2D9CDB" @click="isEditing = true">編集</vs-button>
                <vs-button class="insert-button" color="#BDBDBD" @click="popupActive=true">削除</vs-button>
              </template>
              <template v-else-if="isEditMode">
                <vs-button color="#BDBDBD" @click="cancelEdit">キャンセル</vs-button>
                <vs-button :disabled="!activeInsertButton" class="insert-button" color="#2D9CDB" @click="updateData">保存</vs-button>
              </template>
              <template v-else>
                <vs-button color="#BDBDBD" :to="{name: 'addon-port-master-vessel-master'}">キャンセル</vs-button>
                <vs-button :disabled="!activeInsertButton" class="insert-button" color="#2D9CDB" @click="insertData">登録</vs-button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <vs-popup class="basic-master-popup"  title="船舶の削除" :active.sync="popupActive">
        <p>
          「{{inputs.label.value || inputs.name.value}}」を削除してよろしいですか？
        </p>
        <div class="button-area">
          <vs-button class="popup-button" color="#BDBDBD" @click="popupActive = false">キャンセル</vs-button>
          <vs-button class="popup-button" color="#2D9CDB" @click="callDelete">削除</vs-button>
        </div>
      </vs-popup>
      <error-dialog
        ref="errorDialog"
      ></error-dialog>
    </div>
  </div>
</template>

<script>

import ErrorDialog from "../components/ErrorDialog";
import Multiselect from 'vue-multiselect';
import ColorChip from "../components/ColorChip"
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    Multiselect,
    ColorChip,
    ErrorDialog,
  },
  props: {
    mode: { type: String, required: true }, // "view" or "insert"
    lastSearchCondition: { type: Object }
  },
  data() {
    return {
      isEditing: false,
      options: [
      ],
      inputs: {
        label: {
          label: "船舶名称",
          value: null,
          originalValue: null,
        },
        name: {
          label: "船舶名",
          value: null,
          originalValue: null,
        },
        adminCode: {
          label: "管理コード",
          value: null,
          originalValue: null,
        },
        mmsi: {
          label: "MMSI",
          value: null,
          originalValue: null,
        },
        imo: {
          label: "IMO",
          value: null,
          originalValue: null,
        },
        callSign: {
          label: "コールサイン",
          value: null,
          originalValue: null,
        },
        tonnage: {
          label: "トン数",
          value: null,
          originalValue: null,
        },
        defaultVehiclesCount: {
          label: "車両台数",
          value: null,
          originalValue: null,
        },
        defaultTugboatsCount: {
          label: "タグボート数",
          value: null,
          originalValue: null,
        },
        defaultRopePickingBoatsCount: {
          label: "綱ボート数",
          value: null,
          originalValue: null,
        },
        headCount: {
          label: "作業人数(入港)",
          value: null,
          originalValue: null,
        },
        departureHeadCount: {
          label: "作業人数(出港)",
          value: null,
          originalValue: null,
        },
        tags: {
          label: "注意書き",
          value: [],
          originalValue: null,
        },
        requiredNote: {
          label: "備考",
          value: null,
          originalValue: null,
        },
      },
      createdAt: "",
      updatedAt: "",
      version: null,
      appendixVersion: null,
      inputValues: [],
      popupActive: false,
    }
  },
  async created() {
    this.$vs.loading()
    let res = await this.fetchTags(this.selectedPort.id)
    this.options = res.tags
    if (this.isViewMode) {
      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
      }
      let res = await this.fetchVesselDetail(payload)
      let vessel = res.vessel
      
      this.inputs.label.value = vessel.label
      this.inputs.name.value = vessel.name
      this.inputs.mmsi.value = vessel.mmsi
      this.inputs.imo.value = vessel.imo
      this.inputs.adminCode.value = vessel.admin_code
      this.inputs.callSign.value = vessel.call_sign
      this.inputs.tonnage.value = vessel.tonnage
      this.inputs.headCount.value = vessel.appendix.head_count
      this.inputs.departureHeadCount.value = vessel.appendix.departure_head_count
      this.inputs.requiredNote.value = vessel.appendix.required_note
      this.inputs.defaultRopePickingBoatsCount.value = vessel.appendix.default_rope_picking_boats_count
      this.inputs.defaultTugboatsCount.value = vessel.appendix.default_tugboats_count
      this.inputs.defaultVehiclesCount.value = vessel.appendix.default_vehicles_count
      this.inputs.tags.value = vessel.tags.map(element => element.tag)

      this.createdAt = vessel.created_at ? moment(vessel.created_at).format('YYYY-MM-DD HH:mm:ss') : ""
      this.updatedAt = vessel.updated_at ? moment(vessel.updated_at).format('YYYY-MM-DD HH:mm:ss') : ""

      this.version = vessel.version
      this.appendixVersion = vessel.appendix.version

      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].originalValue = this.inputs[key].value
      })
    }
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
    }),
    isViewMode() {
      return this.mode == "view" && !this.isEditing
    },
    isEditMode() {
      return this.isEditing
    },
    activeInsertButton() {
      let regex = /.+/
      return this.inputs.name.value ? this.inputs.name.value.match(regex) : false
    }
  },
  methods: {
    ...mapActions(["insertVessel", "fetchTags", "fetchVesselDetail", "updateVessel", "deleteVessel"]),
    cancelEdit() {
      this.isEditing = false
      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].value = this.inputs[key].originalValue
      })
    },
    backToMaster() {
      this.$router.push(
        {
          name: "addon-port-master-vessel-master"
        }
      )
    },
    openErrorPopup(title, errorMessage, validationErrors, isValidationError) {
      this.$refs.errorDialog.open(title, errorMessage, validationErrors, isValidationError)
    },
    removeTagById(id){
      this.inputs.tags.value = this.inputs.tags.value.filter(option => option.id != id)
    },
    async callDelete() {
      this.popupActive = false
      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
      }
      try {
        this.$vs.loading()
        await this.deleteVessel(payload)
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-vessel-master"
          }
        )
      } catch(e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        })
      }
    },
    async updateData() {
      let defaultRopePickingBoatsCount = this.inputs.defaultRopePickingBoatsCount.value
      let defaultTugboatsCount = this.inputs.defaultTugboatsCount.value
      let defaultVehiclesCount = this.inputs.defaultVehiclesCount.value
      let headCount = this.inputs.headCount.value
      let departureHeadCount = this.inputs.departureHeadCount.value
      let requiredNote = this.inputs.requiredNote.value
      let callSign = this.inputs.callSign.value
      let imo = this.inputs.imo.value
      let mmsi = this.inputs.mmsi.value
      let label = this.inputs.label.value
      let adminCode = this.inputs.adminCode.value
      let name = this.inputs.name.value
      let tonnage = this.inputs.tonnage.value
      let tags = this.inputs.tags.value.map(element => {
          return { tag_id: element.id }
        }
      )

      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
        body: {
          appendix: {
            default_rope_picking_boats_count: defaultRopePickingBoatsCount, //標準綱取りボート台数
            default_tugboats_count: defaultTugboatsCount, //標準タグボート台数
            default_vehicles_count: defaultVehiclesCount, //標準車両台数
            head_count: headCount, //人数(入港)
            departure_head_count: departureHeadCount, //人数(出港)
            required_note: requiredNote, //注意書き
            
            version: this.appendixVersion
          },
          call_sign: callSign, //コールサイン
          imo: imo, //船舶IMO
          label: label, //船舶ラベル
          mmsi: mmsi, //船舶MMSI
          name: name, //船舶名
          tonnage: tonnage, //船舶トン数
          tags: tags,
          admin_code: adminCode,

          version: this.version
        }
      }
      
      try {
        this.$vs.loading()
        await this.updateVessel(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-vessel-master",
            params: { lastSearchCondition: this.lastSearchCondition }
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let target = null
            if (element.target == "pmEnterprisePortVesselAppendix.defaultVehiclesCount" ||
                element.target == "pmEnterprisePortVesselAppendix.defaultTugboatsCount" ||
                element.target == "pmEnterprisePortVesselAppendix.defaultRopePickingBoatsCount" ||
                element.target == "pmEnterprisePortVesselAppendix.headCount" ||
                element.target == "pmEnterprisePortVesselAppendix.departureHeadCount" ||
                element.target == "pmEnterprisePortVesselAppendix.requiredNote") 
            {
              target = element.target.replace("pmEnterprisePortVesselAppendix.", "")
            } else {
              target = element.target
            }

            let label = this.inputs[target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    },
    async insertData() {
      let defaultRopePickingBoatsCount = this.inputs.defaultRopePickingBoatsCount.value
      let defaultTugboatsCount = this.inputs.defaultTugboatsCount.value
      let defaultVehiclesCount = this.inputs.defaultVehiclesCount.value
      let headCount = this.inputs.headCount.value
      let departureHeadCount = this.inputs.departureHeadCount.value
      let requiredNote = this.inputs.requiredNote.value
      let callSign = this.inputs.callSign.value
      let adminCode = this.inputs.adminCode.value
      let imo = this.inputs.imo.value
      let mmsi = this.inputs.mmsi.value
      let label = this.inputs.label.value
      let name = this.inputs.name.value
      let tonnage = this.inputs.tonnage.value
      let tags = this.inputs.tags.value.map(element => {
          return { tag_id: element.id }
        }
      )

      let payload = {
        portId: this.selectedPort.id,
        body: {
          appendix: {
            default_rope_picking_boats_count: defaultRopePickingBoatsCount, //標準綱取りボート台数
            default_tugboats_count: defaultTugboatsCount, //標準タグボート台数
            default_vehicles_count: defaultVehiclesCount, //標準車両台数
            head_count: headCount, //人数(入港)
            departure_head_count: departureHeadCount, //人数(出港)
            required_note: requiredNote, //注意書き
          },
          call_sign: callSign, //コールサイン
          imo: imo, //船舶IMO
          admin_code: adminCode,
          label: label, //船舶ラベル
          mmsi: mmsi, //船舶MMSI
          name: name, //船舶名
          tonnage: tonnage, //船舶トン数
          tags: tags,
          version: null
        }
      }
      try {
        this.$vs.loading()
        await this.insertVessel(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-vessel-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let target = null
            if (element.target == "pmEnterprisePortVesselAppendix.defaultVehiclesCount" ||
                element.target == "pmEnterprisePortVesselAppendix.defaultTugboatsCount" ||
                element.target == "pmEnterprisePortVesselAppendix.defaultRopePickingBoatsCount" ||
                element.target == "pmEnterprisePortVesselAppendix.headCount" ||
                element.target == "pmEnterprisePortVesselAppendix.departureHeadCount" ||
                element.target == "pmEnterprisePortVesselAppendix.requiredNote") 
            {
              target = element.target.replace("pmEnterprisePortVesselAppendix.", "")
            } else {
              target = element.target
            }

            let label = this.inputs[target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#vessel-form {
  .vs-con-textarea {
    margin: 0px;
  }
  .vx-card {
    min-width: 950px;
  }
  .insert-data-container {
    display: flex;
    justify-content: space-between;
  }
  .title-area {
    display: flex;
  }
  .title {
    font-size: 18px;
  }
  .title-area {
    display: flex;
  }
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    color: #2D9CDB;
    cursor: pointer;
  }
  .input-area {
    width: 100%;
  }
  .input-group {
    width: 100%;
    display: flex;
  }
  .input-column {
    width: 400px;
  }
  .right-column {
    margin-left: 60px;
  }
  .small-input-row {
    display: flex;
    justify-content: space-between;
    .string-input {
      margin-right: 20px;
    }
  }
  .required-note-input {
    flex-grow: 1;
  }
  .input-row {
    margin: 20px 0px;
  }
  .string-input, .color-input, .select-input {
    min-height: 42px;
    display: flex;
    align-items: center;
  }
  .text-are-input {
    display: flex;
  }
  .tag-area {
    line-height: 1;
  }
  .read-only-tag {
    margin-bottom: 0px;
  }
  .multiselect__tag-icon:hover {
    background: $pm-mouse-gray;
  }
  .multiselect__option--selected {
    background: $pm-blue;
    color: $pm-white;
    &:after {
      background: $pm-blue;
      color: $pm-white;
    }
  }
  .multiselect__option {
    font-weight: normal !important;
  }
  .multiselect__option--selected.multiselect__option--highlight {
    background: $pm-mouse-gray;
    color: $pm-white;
    &:after {
      background: $pm-mouse-gray;
      color: $pm-white;
    }
  }
  .multiselect__option--highlight {
    background: $pm-light-blue;
    color: $pm-blue;
    &:after {
      background: $pm-light-blue;
      color: $pm-blue;
    }
  }
  .multiselect__tag-icon:after {
    color: $pm-black;
  }
  .label-input, .name-input {
    width: 300px;
  }
  .number-input {
    width: 40px;
  }
  .label {
    min-width: 110px;
  }
  .validation-label {
    color: red;
    margin-left: 4px;
  }
  .insert-button {
    margin-top: 10px;
    margin-left: 10px;
  }
  .tag-option-item {
    display: flex;
    align-items: center;
  }
}
</style>
